import ApiUrls from "Definations/ApiUrls";
import httpRequest from "Utilities/SetAuthToken";

export const getUserList = async () => {
    return httpRequest.get(`${ApiUrls.getUsers}`);
}

export const getUserActivity = async (data: { page: number, user_email: string }) => {
    return httpRequest.get(`${ApiUrls.getUserActivity}`, {
        params: {
            page: data.page,
            user_email: data.user_email
        }
    });
}

export const getTemplateHistory = async (page: number) => {
    return httpRequest.get(`${ApiUrls.templateHistory}`, {
        params: { page }
    });
}

export const getReportedConstruction = async (page: number) => {
    return httpRequest.get(`${ApiUrls.allReportedCONSTRUCTION}`, {
        params: { page }
    });
}

export const deleteReportedConstruction = async (id: number | undefined) => {
    return httpRequest.get(`${ApiUrls.reportedConstructionDelete}${id}`);
}

export const getReportedOccupancy = async (page: number) => {
    return httpRequest.get(`${ApiUrls.allReportedOccupancy}`, {
        params: { page }
    });
}

export const getColumnMappings = async (page: number, search: string) => {
    return httpRequest.get(`${ApiUrls.columnMappings}`, {
        params: search ? { page, search_by: search } : { page }
    });
}

export const deleteColumnMappings = async (ids: number[]) => {
    return httpRequest.post(`${ApiUrls.deleteColumnMappings}`, { ids });
}

export const deleteReportedOccupancy = async (id: number | undefined) => {
    return httpRequest.get(`${ApiUrls.reportedOccupancyDelete}${id}`);
}


